import React from 'react';
import utilities from "../../modules/Utilities.module.scss";

export default () => {
    return (
        <div className={utilities.loaderContainer}>
            <div className={utilities.loader}></div>
            <span>Loading...</span>
        </div>
    )
}